export default {
    // 汇总页
    getCheckApproval: "/checkApproval/show",
    // util_payment详情页
    checkApprovalShowOther: "/checkApproval/showOther",
    // util_payment详情页
    getCheckApprovalList: "/checkApproval/list",
    // MonrhlyMaintenance详情页
    getApprovalMaintenanceList: "/checkApproval/showMonthly",
    // approve
    getCheckApprovalApprove: "/checkApproval/approve",
    //  Main.Contractor 详情页
    getCheckMainContractor:"/checkApproval/showMainContractor",
    //  GardenerAP 详情页
    getCheckGardenerAP:"/checkApproval/showGardener",
       // MajorProject 详情页
    getCheckMajorProject:"/checkApproval/showMajorProject",
    // CheckApproval详情总数
    checkApprovalShowDetail:"/checkApproval/showDetail",
    // MonthlyWorke详情页老板页面
    checkShowMonthlyWorkerDetail:"/checkApproval/showMonthlyWorker",
    // MonthlyWorke二级详情页老板页面
    checkShowMonthlyWorkerSubDetail:"/checkApproval/showMonthlyWorkerDetail",
    // business_license详情页
    CAshowBusinessLicense:"/checkApproval/showBusinessLicense",
    // maintenanceMaterialAp详情页
    CAMaintenanceMaterialAp:"/checkApproval/maintenanceMaterialAp",
    // Insurance详情页
    CAInsurance:"/checkApproval/showInsurance",
    // 老板批量审批拒绝
    getApproveAll:"/checkApproval/approveAll",
    // 获取批量拒绝的ids
     getApproveAllIds:"/checkApproval/approveAllIds",
    // insurance页面根据propId来展示近三年得金额
    CAInsuranceAmount: "/checkApproval/propByInsuranceAmount",
}